export default __webpack_public_path__ + "static/media/5e3be609f638030fc17305342f13a6aa.svg";